import GoogleMapReact from 'google-map-react'
import styles from './styles.module.scss'
import IconMarker from '/public/icons/icon-marker.svg'
import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { withModifiers } from '../../../helpers/withModifiers'
import { useState, useEffect } from 'react'

// to be moved to elements Map
const Map = ({ lat, lng, points, variant = [] }) => {
  const { isMobile, isTablet } = useResponsive()
  const [maps, setMaps] = useState(false)

  const hasSection = variant.includes('section')
  const [loaded, setLoaded] = useState(false)

  const Marker = () => (
    <div className={styles.map__marker}>
      <IconMarker />
    </div>
  )

  useEffect(() => {
    const onPageLoad = () => {
      setLoaded(true)
    }

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad()
    } else {
      window.addEventListener('load', onPageLoad)
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad)
    }
  }, [])

  if (!loaded && (!lng || !lat || points)) {
    return
  }

  const defaultProps = {
    center: {
      lat: Number(lat) || Number(points[0]?.lat),
      lng: points ? Number(points[0]?.lng) : Number(lng)
    },
    zoom: isMobile ? 12 : 13
  }

  if (hasSection) {
    return (
      <Section className={styles.section} variant={['p0']}>
        <Container variant={[isTablet && '-p0']}>
          <div className={styles.map}>
            <GoogleMapReact
              bootstrapURLKeys={{
                // eslint-disable-next-line no-undef
                key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
              }}
              onGoogleApiLoaded={({ maps }) => setMaps(maps)}
              options={{
                mapTypeControl: true,
                mapTypeControlOptions: maps && {
                  mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE]
                }
              }}
              yesIWantToUseGoogleMapApiInternals
              center={defaultProps.center}
              zoom={defaultProps.zoom}
            >
              {points ? (
                points.map((item, index) => (
                  <Marker key={index} lng={item.lng} lat={item.lat} />
                ))
              ) : (
                <Marker lng={lng} lat={lat} />
              )}
            </GoogleMapReact>
          </div>
        </Container>
      </Section>
    )
  }

  return (
    <div className={withModifiers('map', ['full-width'], styles)}>
      <GoogleMapReact
        bootstrapURLKeys={{
          // eslint-disable-next-line no-undef
          key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
        }}
        yesIWantToUseGoogleMapApiInternals
        center={defaultProps.center}
        zoom={defaultProps.zoom}
        onGoogleApiLoaded={({ maps }) => setMaps(maps)}
        options={{
          mapTypeControl: true,
          mapTypeControlOptions: maps && {
            mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE]
          }
        }}
      >
        {points ? (
          points.map((item, index) => (
            <Marker key={index} lng={item.lng} lat={item.lat} />
          ))
        ) : (
          <Marker lng={lng} lat={lat} />
        )}
      </GoogleMapReact>
    </div>
  )
}
export default Map
